<script setup lang="ts">
    import KCell from "@/components/KTable/KCell.vue";
    import { computed, toRefs } from "vue";

    const props = defineProps<{
        data?: string[];
    }>();

    const { data } = toRefs(props);

    const tooltipContent = computed(() => {
        return data?.value?.map((row) => `<p>${row}</p>`).join("");
    });
</script>

<template>
    <KCell truncate class="cell-remisser" contentDirection="vertical" :tooltipContent="tooltipContent">
        <template #content>
            <span v-for="(content, index) in data" :key="index">
                {{ content }}
            </span>
        </template>
    </KCell>
</template>

<style scoped lang="scss">
    .cell-remisser {
    }
</style>
